import React from 'react';
import { useTranslation } from 'react-i18next';
import Menu from '../../components/Menu'
import Header from '../../components/Header'
import { ReactComponent as IconDeals } from '../../images/icn_offerte.svg'
import Filters from '../../components/Filters'
import { UncontrolledCollapse, Button, Card, CardBody } from 'reactstrap'
import Footer from '../../components/Footer'
import BurgerMenu from '../../components/BurgerMenu'
import DealsTable from './DealsTable';
import SearchAddCont from '../../components/SearchAddCont';
import { FILTERS } from '../../constants/filters';
import { Kpi } from '../../components/Kpi/Kpi';
import { KpisWrapper } from '../../components/KpisWrapper/KpisWrapper';
import { formatCurrency } from '../../lib/helpers/formatters';

function DealsPresentational(props) {
  const {
    total = 0,
    deals,
    kpis,
    query = {},
    onFilter,
    onCreateDeal,
    isLoading = false,
    isAdding = false,
  } = props;

  const [t] = useTranslation('DEALS');

  return (
    <div className="App">
      <Menu />

      <div className="corpo">
        <section>
          <Header
            title={t('TITLE')}
            icon={<IconDeals fill='#FF6B38' />}
          />

          <div className="row">
            <div className="col-6">
              <Button className="btn-collapse" id="toggler" style={{ marginBottom: '1rem' }}>
                {t('COMMON:FILTER_BY')} <i className="fas fa-filter"></i>
              </Button>
            </div>
            <div className="col-6 text-right">
              <SearchAddCont
                isLoading={isAdding}
                onFilter={onFilter}
                query={query}
                onAdd={onCreateDeal}
                addLabel={t('ADD_OFFER')}
                addConfirm={t('ADD_REQUEST')}
              />
            </div>
          </div>

          <UncontrolledCollapse toggler="#toggler">
            <div className="m-t-20">
              <Filters
                query={query}
                onFilter={onFilter}
                list={[FILTERS.COMPANY_ID, FILTERS.CONTACT_ID, FILTERS.USER_ID, FILTERS.OFFER_TYPE, FILTERS.STAGE, FILTERS.COST_CENTER, FILTERS.SEARCH, FILTERS.SUCCESS_PERCENTAGE, FILTERS.FROM, FILTERS.TO]}
              />
            </div>
          </UncontrolledCollapse>

          <hr />

          <Card>
            <CardBody>
              <KpisWrapper>
                <Kpi title={t('COMMON:DEALS_TOTAL')} value={formatCurrency(kpis?.sum ?? 0)} />
                <Kpi title={t('COMMON:WEIGHTED_REVENUE')} value={formatCurrency(kpis?.weighted_revenue ?? 0)} />
                <Kpi title={t('COMMON:SUCCESS_RATE_AVERAGE')} value={kpis?.success_rate ?? 'N/A'} />
              </KpisWrapper>
              <DealsTable
                deals={deals}
                total={total}
                query={query}
                onFilter={onFilter}
                isLoading={isLoading}
              />
            </CardBody>
          </Card>

        </section>
        <Footer />
      </div>

      <BurgerMenu />
    </div >
  )
}

export default DealsPresentational
